import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
//import "bootstrap-icons";

import Vue from "vue";
import VueLocalStorage from "vue-localstorage";
import VueClipboard from "vue-clipboard2";
import App from "./App.vue";
//import VueAnalytics from "vue-analytics";

import router from "./router.js";

import util from "./includes/util.js";
import { global } from "./includes/global.js";

window.$ = require("jquery");
window.JQuery = require("jquery");

Vue.config.productionTip = false;

Vue.config.devtools = false;
Vue.config.debug = false;
Vue.config.silent = true;

Vue.prototype.$sessao = util.localStorageItem("ckdCch");
Vue.prototype.$darkMode = localStorage.getItem("darkMode", "false");
Vue.prototype.$global = global;

if (Vue.prototype.$darkMode == null) {
	Vue.prototype.$darkMode = "false";
}

Vue.use(VueLocalStorage);
Vue.use(VueClipboard);

/*
Vue.use(VueAnalytics, {
  id: "G-B49DE8P44G",
  router
});
id: "UA-175262217-1",
*/
new Vue({
	router,
	render: (h) => h(App)
}).$mount("#app");
